import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import PrivateRoute from './components/PrivateRoute';
import NotificationDisplay from './components/NotificationDisplay';
import ModalLgpd from './components/ModalLgpd';
import PerfilRoute from './components/PerfilRoute';
import SaasLoginPage from './saas/SaasLoginPage';
import SaasRegisterPage from './saas/SaasRegisterPage';
import SaasDashboard from './saas/SaasDashboard';
import SaasPrivateRoute from './saas/SaasPrivateRoute';
import Layout from './components/Layout';

import LoginPage from './auth/LoginPage';
import ResetPasswordPage from './auth/ResetPasswordPage';
import ConfirmInvitePage from './users/ConfirmInvitePage';
import LandingPage from './pages/LandingPage';
import PublicHomePage from './pages/PublicHomePage';
import DashboardPage from './pages/DashboardPage';
import DashboardSaasPage from './pages/DashboardSaasPage';
import CrechesPage from './creches/CrechesPage';
import TurmasPage from './turmas/TurmasPage';
import SalasPage from './turmas/SalasPage';
import DemandaPage from './demanda/DemandaPage';
import VisitasPage from './visitas/VisitasPage';
import PaginaPublicaPage from './paginapublica/PaginaPublicaPage';
import PublicCrechePage from './paginapublica/PublicCrechePage';
import CompletarCadastroMatriculaPage from './paginapublica/CompletarCadastroMatriculaPage';
import SecretariaPage from './secretaria/SecretariaPage';
import AlunosPage from './alunos/AlunosPage';
import FinanceiroPage from './financeiro/FinanceiroPage';
import CardapiosPage from './cardapios/CardapiosPage';
import NutricaoPage from './nutricao/NutricaoPage';
import CalendarioPage from './calendario/CalendarioPage';
import ComunicacaoPage from './comunicacao/ComunicacaoPage';
import AtendimentosEspeciaisPage from './atendimentos-especiais/AtendimentosEspeciaisPage';
import RotinaPage from './rotina/RotinaPage';
import UsuariosPage from './users/UsuariosPage';
import FamiliasPage from './familias/FamiliasPage';
import FuncionariosPage from './funcionarios/FuncionariosPage';
import PedagogicoPage from './pedagogico/PedagogicoPage';
import AdministrativoPage from './administrativo/AdministrativoPage';
import InfraestruturaPage from './infraestrutura/InfraestruturaPage';
import SegurancaPage from './seguranca/SegurancaPage';
import SaudePage from './saude/SaudePage';
import PortalPaisPage from './portal-pais/PortalPaisPage';
import MeuPainelPage from './funcionarios/MeuPainelPage';
import PresencaPage from './presenca/PresencaPage';
import RelatoriosPage from './pages/RelatoriosPage';
import AssistenteIAPage from './ia/AssistenteIAPage';
import ImportacaoPage from './importacao/ImportacaoPage';
import ShowcaseLizDemo from './ia/ShowcaseLizDemo';

function AppPrivado() {
  return (
    <Layout>
      <Routes>
        <Route path="sistema" element={<PerfilRoute routePath="/app/sistema"><DashboardSaasPage /></PerfilRoute>} />
        <Route index element={<PerfilRoute routePath="/app"><DashboardPage /></PerfilRoute>} />
        <Route path="creches" element={<PerfilRoute routePath="/app/creches"><CrechesPage /></PerfilRoute>} />
        <Route path="salas" element={<PerfilRoute routePath="/app/salas"><SalasPage /></PerfilRoute>} />
        <Route path="turmas" element={<PerfilRoute routePath="/app/turmas"><TurmasPage /></PerfilRoute>} />
        <Route path="demanda" element={<PerfilRoute routePath="/app/demanda"><DemandaPage /></PerfilRoute>} />
        <Route path="visitas" element={<PerfilRoute routePath="/app/visitas"><VisitasPage /></PerfilRoute>} />
        <Route path="pagina-publica" element={<PerfilRoute routePath="/app/pagina-publica"><PaginaPublicaPage /></PerfilRoute>} />
        <Route path="secretaria" element={<PerfilRoute routePath="/app/secretaria"><SecretariaPage /></PerfilRoute>} />
        <Route path="alunos" element={<PerfilRoute routePath="/app/alunos"><AlunosPage /></PerfilRoute>} />
        <Route path="financeiro" element={<PerfilRoute routePath="/app/financeiro"><FinanceiroPage /></PerfilRoute>} />
        <Route path="cardapios" element={<PerfilRoute routePath="/app/cardapios"><CardapiosPage /></PerfilRoute>} />
        <Route path="nutricao" element={<PerfilRoute routePath="/app/nutricao"><NutricaoPage /></PerfilRoute>} />
        <Route path="calendario" element={<PerfilRoute routePath="/app/calendario"><CalendarioPage /></PerfilRoute>} />
        <Route path="comunicacao" element={<PerfilRoute routePath="/app/comunicacao"><ComunicacaoPage /></PerfilRoute>} />
        <Route path="atendimentos" element={<PerfilRoute routePath="/app/atendimentos"><AtendimentosEspeciaisPage /></PerfilRoute>} />
        <Route path="rotina" element={<PerfilRoute routePath="/app/rotina"><RotinaPage /></PerfilRoute>} />
        <Route path="presenca" element={<PerfilRoute routePath="/app/presenca"><PresencaPage /></PerfilRoute>} />
        <Route path="usuarios" element={<PerfilRoute routePath="/app/usuarios"><UsuariosPage /></PerfilRoute>} />
        <Route path="familias" element={<PerfilRoute routePath="/app/familias"><FamiliasPage /></PerfilRoute>} />
        <Route path="funcionarios" element={<PerfilRoute routePath="/app/funcionarios"><FuncionariosPage /></PerfilRoute>} />
        <Route path="pedagogico" element={<PerfilRoute routePath="/app/pedagogico"><PedagogicoPage /></PerfilRoute>} />
        <Route path="administrativo" element={<PerfilRoute routePath="/app/administrativo"><AdministrativoPage /></PerfilRoute>} />
        <Route path="infraestrutura" element={<PerfilRoute routePath="/app/infraestrutura"><InfraestruturaPage /></PerfilRoute>} />
        <Route path="seguranca" element={<PerfilRoute routePath="/app/seguranca"><SegurancaPage /></PerfilRoute>} />
        <Route path="saude" element={<PerfilRoute routePath="/app/saude"><SaudePage /></PerfilRoute>} />
        <Route path="meu-filho" element={<PerfilRoute routePath="/app/meu-filho"><PortalPaisPage /></PerfilRoute>} />
        <Route path="meu-painel" element={<PerfilRoute routePath="/app/meu-painel"><MeuPainelPage /></PerfilRoute>} />
        <Route path="ia" element={<PerfilRoute routePath="/app/ia"><AssistenteIAPage /></PerfilRoute>} />
        <Route path="relatorios" element={<PerfilRoute routePath="/app/relatorios"><RelatoriosPage /></PerfilRoute>} />
        <Route path="importar" element={<PerfilRoute routePath="/app/importar"><ImportacaoPage /></PerfilRoute>} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
    </Layout>
  );
}

export function AppRoutes() {
  return (
    <BrowserRouter>
      <NotificationProvider>
        <AuthProvider>
          <ModalLgpd />
          <NotificationDisplay />
          <Routes>
          {/* ─── Portal SaaS (Exclusivo) ────────────────────────── */}
          <Route path="/saas/login" element={<SaasLoginPage />} />
          <Route path="/saas/register" element={<SaasRegisterPage />} />
          <Route element={<SaasPrivateRoute />}>
            <Route path="/saas/dashboard" element={<SaasDashboard />} />
            <Route path="/saas" element={<Navigate to="/saas/dashboard" replace />} />
          </Route>

          {/* ─── Aplicativo Creche ─────────────────────────────── */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/portal" element={<PublicHomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
          <Route path="/confirm-invite" element={<ConfirmInvitePage />} />
          <Route path="/showcase-liz" element={<ShowcaseLizDemo />} />
          <Route path="/c/:slug" element={<PublicCrechePage />} />
          {/* Convite ao responsável: vaga confirmada, finalize o cadastro (sem login) */}
          <Route path="/matricula/:token" element={<CompletarCadastroMatriculaPage />} />
          <Route
            path="/app/*"
            element={
              <PrivateRoute>
                <AppPrivado />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  );
}
